import type { JSX } from 'react';
import { cn } from '@/lib/utils';
import { button } from '../shell/look';

/** "← Choose another" on the left, the verify button on the right (design L636–639). */
export function FormFooter({
  back,
  label,
  busy,
}: {
  back: { label: string; run: () => void };
  label: string;
  busy: boolean;
}): JSX.Element {
  return (
    <div className="mt-auto flex items-center justify-between pt-2">
      <button
        type="button"
        onClick={back.run}
        className="text-mute hover:text-ink border-0 bg-transparent text-[13px]"
      >
        {back.label}
      </button>
      <button
        type="submit"
        disabled={busy}
        className={cn(button.primary, 'min-w-[150px] px-[18px]')}
      >
        {label}
      </button>
    </div>
  );
}
